import React, { useState, useRef } from "react";
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import { withRouter } from '../../../shared/hoc/withRouter';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import { injectIntl } from "react-intl";
import * as assetCrud from "../../../crud/asset.crud";
import { withSnackbar } from 'notistack';
import { useSelector } from "react-redux";
import * as customFieldCrud from "../../../crud/customField.crud";
import Common from '../../../shared/common';
import { listAccountsAllowedDeleteDraft, listAccountsAllowedExportImportDocumentJSON } from '../../../router/Protector/AccessExceptions';
import * as administratorCrud from "../../../crud/administrator.crud";
import { confirm } from 'devextreme/ui/dialog';
import ContractActionCreateModal from '../../admin/Contracts/Contract/Helpers/ContractActionCreateModal';
import ActionDownloadModal from './ActionDownloadModal';
import SystemHelper from "../../../shared/systemHelper";
import ActionCopyToOtherInstanceModal from './ActionCopyToOtherInstanceModal';

const isAssociatedNoticeEnabled = process.env.REACT_APP_CREATE_ASSOCIATED_NOTICE_ENABLED === 'true';
const isShareButtonEnabled = process.env.REACT_APP_SHARE_BUTTON_ENABLED === 'true';
const isDownloadButtonEnabled = process.env.REACT_APP_DOWNLOAD_BUTTON_ENABLED === 'true' //&& process.env.REACT_APP_ENVIRONMENT !== 'PROD';
const copyNotificationToOtherInstanceEnabled = process.env.REACT_APP_COPY_NOTIFICATION_TO_OTHER_INSTANCE_ENABLED === 'true';

const exportJSON = (jsonData) => {
    const stringifiedJson = JSON.stringify(JSON.parse(jsonData), null, 2);
    Common.downloadFile({
        data: stringifiedJson,
        fileName: 'Document.json',
        fileType: 'text/json',
    });
}

const PageToolbar = (props) => {
    const isAssetsEnabled = SystemHelper.getSettingValueBoolean(SystemHelper.SETTINGS.ASSETS_ENABLED);
    const userProfile = useSelector(store => store.auth.userProfile);
    const [disabled, setDisabled] = useState(false);
    const [showAddActionModal, setShowAddActionModal] = useState(false);
    const [showActionCopyToOtherInstanceModal, setShowCopyToOtherInstanceModal] = useState(false);
    const [includemain, setIncludeMain] = useState(false);
    const [includereply, setIncludeReply] = useState(false);
    const [showActionDownloadModal, setShowActionDownloadModal] = useState(false);

    const {
        documentIsFinal,
        intl,
        workflowItem,
        params,
        actions,
        relationParams
    } = props;

    const isPdfJsonContentAvailable = props.notification.pdfjsoncontent !== "";
    const isPdfReplyJsonContentAvailable = props.notification.pdfreplyjsoncontent !== "";

    const onDownloadActionClicked = (option) => {
        if (option === "main") {
            setIncludeMain(true);
            setIncludeReply(false);
        } else if (option === "reply") {
            setIncludeMain(false);
            setIncludeReply(true);
        } else if (option === "mainAndReply") {
            setIncludeMain(true);
            setIncludeReply(true);
        }

        setShowActionDownloadModal(true);
    };

    const relatedActions = isAssociatedNoticeEnabled && actions && actions.showModal && workflowItem.associatedWFListAllowed ? workflowItem.associatedWFListAllowed : [];

    let communicateReplyAllowed = (workflowItem.userFilters.replyNotice || {}).communicateReplyAllowed;
    let saveDraftReplyAllowed = (workflowItem.userFilters.replyNotice || {}).saveDraftReplyAllowed;
    if (props.overrideReplyParty) {
        communicateReplyAllowed = props.overrideCommunicateReplyAllowed;
        saveDraftReplyAllowed = props.overrideSaveDraftReplyAllowed;
    }

    const fileImportJSONInputRef = useRef(null);
    const fileImportReplyJSONInputRef = useRef(null);

    const onBtnAddActionClicked = () => {
        SystemHelper.hubspotUpdateEvent("NOTICE_CREATE_RELATED_ACTION");
        setShowAddActionModal(true);
    }
    const onAddActionDialogResult = (result) => {
        setShowAddActionModal(false);
    }


    const onCopyToOtherInstanceClicked = () => {
        setShowCopyToOtherInstanceModal(true);
    }
    const onCopyToOtherInstanceDialogResult = (result) => {
        setShowCopyToOtherInstanceModal(false);
    }

    const onDownloadActionDialogResult = (result) => {
        setShowActionDownloadModal(false);
    }


    const importJSON = (isReply) => {
        if (isReply) {
            if (fileImportReplyJSONInputRef.current) {
                fileImportReplyJSONInputRef.current.click();
            }
        }
        else {
            if (fileImportJSONInputRef.current) {
                fileImportJSONInputRef.current.click();
            }
        }
    }

    const confirmFileImport = async () => {
        const warningMessage = props.intl.formatMessage({ id: 'GENERAL.FORMS.IMPORT_FILE_WARNING' });
        const warningMessageLabel = props.intl.formatMessage({ id: 'GENERAL.FORMS.IMPORT_FILE_WARNING_LABEL' });
        let result = await confirm(`<div style="max-width:50vw;color: red;">${warningMessage}</div>`, `${warningMessageLabel}`);

        return result;
    }

    const importJSONFileSelected = async (e, isReply) => {
        if (e.stopPropagation) { e.stopPropagation(); }
        if (e.preventDefault) { e.preventDefault(); }
        if (e.target && e.target.files && e.target.files.length > 0) {
            var file = e.target.files[0];
            if (file) {
                try {
                    const fileImportConfirmed = await confirmFileImport();

                    if (!fileImportConfirmed) {
                        //if not confirmed exit save
                        //setSubmitting(false);
                        return;
                    }
                    else {
                        const text = await file.text();
                        const importedFile = JSON.parse(text);

                        let workflowname = props.workflowItem.config.currentModel;
                        let recordid = props.params.notificationid;

                        //Set quotes based on currentModel
                        //Quote
                        if (props.workflowItem.config.currentModel === "CompensationEvent" && params.quotationid) {
                            workflowname = "Quotation";
                            recordid = params.quotationid;
                        } else if (props.workflowItem.config.currentModel === "Rfq") { //RfqQuote
                            if (params.quotationid) {
                                workflowname = "RfqQuotation";
                                recordid = params.quotationid;
                            } else {
                                workflowname = "RequestForQuote";
                            }
                        } else if (props.workflowItem.config.currentModel === "Itq") { //ItqQuote
                            if (params.quotationid) {
                                workflowname = "ItqQuotation";
                                recordid = params.quotationid;
                            } else {
                                workflowname = "InstructionToQuote";
                            }
                        }

                        const newFile = {
                            workflowname: workflowname,
                            recordid: recordid,
                            pdfjson: JSON.stringify(importedFile),
                            isreply: isReply
                            //deleted: 0
                        };

                        await administratorCrud.importFile(newFile);

                        props.enqueueSnackbar(props.intl.formatMessage({ id: 'GENERAL.FORMS.IMPORT_SUCCESS' }), { variant: 'success' });

                        window.location.reload(true);
                    }
                } catch (err) {
                    props.enqueueSnackbar(props.intl.formatMessage({ id: 'GENERAL.FORMS.IMPORT_ERROR' }), { variant: 'error', });
                    console.log(err.toString())
                }
                finally {
                    if (isReply) {
                        if (fileImportReplyJSONInputRef.current) {
                            fileImportReplyJSONInputRef.current.value = null;
                        }
                    }
                    else {
                        if (fileImportJSONInputRef.current) {
                            fileImportJSONInputRef.current.value = null;
                        }
                    }
                }
            }
        }
    }

    const shareButtonOptions = [];
    shareButtonOptions.push({
        text: props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_SHARE_MAINNOTICE' }),
        isReply: false
    });

    if (workflowItem.replyEnabled && documentIsFinal) {
        shareButtonOptions.push({
            text: props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_SHARE_REPLYNOTICE' }),
            isReply: true
        });
    }

    const printButtonOptions = [];
    if (actions && actions.onPrint && props.documentIsFinal) {
        printButtonOptions.push({
            text: props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_PRINT_MAIN_NOTICE' }),
            isReply: false,
            onClick: props.actions.onPrint
        });
    }

    if (actions && actions.onPrintReply && props.documentIsFinal && workflowItem.replyEnabled && !props.isAwaitingReply) {
        printButtonOptions.push({
            text: props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_PRINT_MAIN_NOTICE_REPLY' }),
            isReply: true,
            onClick: props.actions.onPrintReply
        });
    }

    const downloadButtonOptions = [];
    if (props.documentIsFinal && isPdfJsonContentAvailable) {
        downloadButtonOptions.push({
            text: props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_DOWNLOAD_NOTICE_MAIN' }),
            isRely: false,
            onClick: () => onDownloadActionClicked("main"),
        });
    }

    if (isPdfJsonContentAvailable && isPdfReplyJsonContentAvailable && props.documentIsFinal && workflowItem.replyEnabled && !props.isAwaitingReply) {
        downloadButtonOptions.push({
            text: intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_DOWNLOAD_NOTICE_REPLY' }),
            isRely: true,
            onClick: () => onDownloadActionClicked("reply"),
        });

        downloadButtonOptions.push({
            text: intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_DOWNLOAD_NOTICE_MAIN_AND_REPLY' }),
            isRely: true,
            onClick: () => onDownloadActionClicked("mainAndReply"),
        });
    }

    const documentJsonOptions = [];

    documentJsonOptions.push({
        text: props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_EXPORT_NOTICE_JSON' }),
        isReply: false,
        isExport: true
    });

    if (workflowItem.replyEnabled && documentIsFinal) {
        documentJsonOptions.push({
            text: props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_EXPORT_REPLY_NOTICE_JSON' }),
            isReply: true,
            isExport: true
        });
    }

    documentJsonOptions.push({
        text: props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_IMPORT_NOTICE_JSON' }),
        isReply: false
    });

    if (workflowItem.replyEnabled && documentIsFinal) {
        documentJsonOptions.push({
            text: props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_IMPORT_REPLY_NOTICE_JSON' }),
            isReply: true
        });
    }





    return (
        <div style={{ display: 'flex', flex: 1, flexFlow: 'row-reverse', margin: "20px 0px" }}>
            <LoadIndicator className="button-indicator" visible={props.saveDisabled || disabled} />
            {listAccountsAllowedExportImportDocumentJSON.includes(userProfile.accounttype) && (
                <>
                    <input type='file' id='importFile' accept='.json' ref={fileImportJSONInputRef} style={{ display: 'none' }} onChange={async (e) => await importJSONFileSelected(e, false)} />
                    <input type='file' id='importFileReply' accept='.json' ref={fileImportReplyJSONInputRef} style={{ display: 'none' }} onChange={async (e) => await importJSONFileSelected(e, true)} />
                </>
            )}
            <Toolbar
                key={props.key}
                disabled={props.saveDisabled || disabled}
            >
                <ToolbarItem location="after"
                    id={"ptBackToRegister"}
                    key={"ptBackToRegister"}
                    locateInMenu="auto"
                    widget="dxButton"
                    disabled={props.saveDisabled}
                    options={
                        {
                            icon: "back",
                            onClick: () => props.navigate(workflowItem.paths.listPath),
                            text: intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_BACK_REGISTER" }),
                        }
                    }
                />
                {
                    actions && actions.showModal && !documentIsFinal && workflowItem.userFilters.mainNotice.communicateAllowed && relatedActions.length === 0 && (
                        <ToolbarItem location="after"
                            id={"ptCommunicate" + props.key}
                            key={"ptCommunicate" + props.key}
                            locateInMenu="never"
                            widget="dxButton"
                            disabled={props.saveDisabled}
                            options={
                                {
                                    icon: "parentfolder",
                                    onClick: () => { props.actions.showModal('COMMUNICATE', null); },
                                    text: intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_COMMUNICATE_ITEM" }, { ITEM_NAME: workflowItem.notificationName }),
                                    stylingMode: "contained",
                                    type: "success"
                                }
                            }
                        />
                    )
                }
                {
                    actions && actions.showModal && !documentIsFinal && workflowItem.userFilters.mainNotice.communicateAllowed && relatedActions.length > 0 && (
                        <ToolbarItem
                            location="after"
                            id={"ptComAndCreateRelatedDrop" + props.key}
                            key={"ptComAndCreateRelatedDrop" + props.key}
                            locateInMenu="never"
                            widget="dxDropDownButton"
                            disabled={props.saveDisabled}
                            options={
                                {
                                    icon: "parentfolder",
                                    splitButton: true,
                                    useSelectMode: false,
                                    dropDownOptions: { width: 300, maxHeight: '50vh' },
                                    stylingMode: "contained",
                                    displayExpr: 'text',
                                    wrapItemText: true,
                                    elementAttr: { id: "ptComAndCreateRelatedDrop", class: "dx-button-mode-contained dx-button-success", style: "border-radius:4px;" },
                                    items: relatedActions.map(itm => ({
                                        disabled: props.saveDisabled,
                                        icon: "parentfolder",
                                        // stylingMode: "contained",
                                        // type: "success",
                                        text: intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_COMMUNICATE_CREATE_ASSOCIATED_NOTICE" }, { ITEM_NAME: itm.text }),
                                        onClick: () => {
                                            const postActionURL = {
                                                pathname: itm.url,
                                                state: {
                                                    itemBaseProps: {
                                                        ...itm.itemBaseProps,
                                                        refid: params.notificationid,
                                                        path: itm.itemBaseProps.path + params.notificationid
                                                    },
                                                    itemCustomProps: {
                                                        ...relationParams
                                                    }
                                                }
                                            };

                                            props.actions.showModal('COMMUNICATE', postActionURL);
                                        },
                                    })),
                                    onButtonClick: () => { props.actions.showModal('COMMUNICATE', null); },
                                    text: intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_COMMUNICATE_ITEM" }, { ITEM_NAME: workflowItem.notificationName }),
                                }
                            }
                        />
                    )
                }
                {
                    relatedActions.length > 0 && (
                        <ToolbarItem
                            id={"ptCreateRelatedDrop" + props.key}
                            key={"ptCreateRelatedDrop" + props.key}
                            location="after"
                            locateInMenu="never"
                            widget="dxDropDownButton"
                            disabled={props.saveDisabled}
                            // visible={documentIsFinal}
                            options={
                                {
                                    icon: "add",
                                    stylingMode: "outlined",
                                    type: "normal",
                                    displayExpr: 'text',
                                    text: intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_CREATE_RELATED_ITEM" }),
                                    wrapItemText: true,
                                    dropDownOptions: { width: 300, maxHeight: '50vh' },
                                    items: relatedActions.map(itm => ({
                                        disabled: props.saveDisabled,
                                        icon: "add",
                                        text: itm.text,
                                        onClick: () => {
                                            SystemHelper.hubspotUpdateEvent("NOTICE_CREATE_ASSOCIATED_NOTICE");
                                            props.navigate(itm.url, {
                                                state: {
                                                    itemBaseProps: {
                                                        ...itm.itemBaseProps,
                                                        refid: params.notificationid,
                                                        path: itm.itemBaseProps.path + params.notificationid
                                                    },
                                                    itemCustomProps: {
                                                        ...relationParams
                                                    }
                                                }
                                            });
                                        },
                                    })),
                                }
                            }
                        />
                    )

                }
                {
                    actions && actions.showModal && !documentIsFinal && (
                        <ToolbarItem location="after"
                            id={"ptSaveDraft" + props.key}
                            key={"ptSaveDraft" + props.key}
                            locateInMenu="auto"
                            widget="dxButton"
                            disabled={props.saveDisabled}
                            options={
                                {
                                    icon: "save",
                                    onClick: props.actions.showModal.bind(this, 'SAVE_DRAFT', null),
                                    text: intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_SAVE_DRAFT_NOTIFY" })
                                }
                            }
                        />
                    )
                }
                {
                    actions && actions.showModal && !documentIsFinal && listAccountsAllowedDeleteDraft.includes(userProfile.accounttype) && (
                        <ToolbarItem location="after"
                            id={"ptDeleteDraft" + props.key}
                            key={"ptDeleteDraft" + props.key}
                            locateInMenu="auto"
                            widget="dxButton"
                            disabled={props.saveDisabled}
                            options={
                                {
                                    icon: "trash",
                                    onClick: props.actions.showModal.bind(this, 'DELETE_DRAFT', null),
                                    text: intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_DELETE_DRAFT_NOTIFY" })
                                }
                            }
                        />
                    )
                }
                {
                    actions && actions.showModal && documentIsFinal && workflowItem.replyEnabled && props.isAwaitingReply && communicateReplyAllowed && (
                        <ToolbarItem location="after"
                            id={"ptSendReply" + props.key}
                            key={"ptSendReply" + props.key}
                            locateInMenu="never"
                            widget="dxButton"
                            disabled={props.saveDisabled}
                            options={
                                {
                                    icon: "parentfolder",
                                    onClick: props.actions.showModal.bind(this, 'REPLY_SEND', null),
                                    text: intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_SEND_REPLY_ITEM" }, { ITEM_NAME: workflowItem.notificationName }),
                                    stylingMode: "contained",
                                    type: "success"
                                }
                            }
                        />
                    )
                }
                {
                    actions && actions.showModal && props.documentIsFinal && workflowItem.replyEnabled && props.isAwaitingReply && saveDraftReplyAllowed && (
                        <ToolbarItem location="after"
                            id={"ptDraftReply" + props.key}
                            key={"ptDraftReply" + props.key}
                            locateInMenu="auto"
                            widget="dxButton"
                            disabled={props.saveDisabled}
                            options={
                                {
                                    icon: "save",
                                    onClick: props.actions.showModal.bind(this, 'REPLY_DRAFT', null),
                                    text: intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_SAVE_REPLY_DRAFT" })
                                }
                            }
                        />
                    )
                }
                {
                    actions && actions.onPrint && props.documentIsFinal && (
                        <ToolbarItem location="after"
                            locateInMenu="auto"
                            widget="dxDropDownButton"
                            disabled={props.saveDisabled}
                            options={
                                {
                                    icon: "print",
                                    text: 'Print',
                                    displayExpr: 'text',
                                    stylingMode: "outlined",
                                    dropDownOptions: { width: 150 },
                                    items: printButtonOptions.map(itm => ({
                                        disabled: props.saveDisabled,
                                        icon: "print",
                                        text: itm.text,
                                        onClick: itm.onClick
                                    })),
                                }
                            }
                        />
                    )
                }

                {
                    isDownloadButtonEnabled && props.documentIsFinal && (
                        <ToolbarItem location="after"
                            locateInMenu="auto"
                            widget="dxDropDownButton"
                            disabled={props.saveDisabled}
                            options={
                                {
                                    icon: "download",
                                    text: 'Download',
                                    stylingMode: "outlined",
                                    dropDownOptions: { width: 210 },
                                    items: downloadButtonOptions.map(itm => ({
                                        disabled: props.saveDisabled,
                                        icon: "download",
                                        text: itm.text,
                                        onClick: itm.onClick
                                    })),
                                    itemTemplate: (data) => {//adding a tooltip
                                        return (
                                            `<div title="${data.text}" style="display: flex; align-items: center;">
                                                <span class="dx-icon dx-icon-copy" style="font-size: 18px; margin-right: 8px;"></span>
                                                <span style="font-size: 14px;">${data.text}</span>
                                            </div>`
                                        );
                                    }
                                }
                            }
                        />
                    )
                }
                {
                    isShareButtonEnabled && props.referenceid && (
                        <ToolbarItem location="after"
                            locateInMenu="auto"
                            widget="dxDropDownButton"
                            disabled={props.saveDisabled}
                            options={
                                {
                                    text: 'Share',
                                    icon: 'share',
                                    stylingMode: "outlined",
                                    type: "normal",
                                    displayExpr: 'text',
                                    dropDownOptions: { width: 150 },
                                    items: shareButtonOptions.map(itm => ({
                                        disabled: props.saveDisabled,
                                        icon: "share",
                                        text: itm.text,
                                        onClick: async () => {
                                            const referenceidMailto = props.referenceid;
                                            const titleNotification = props.workflowItem.title;
                                            const nameMailto = props.contract.name;
                                            const urlLinkMalito = window.location.href;

                                            let assetName = '';
                                            if (isAssetsEnabled && (props.relationParams || {}).assetid) {
                                                try {
                                                    const { data: strAsset } = await assetCrud.getAsset(props.relationParams.assetid);
                                                    const asset = JSON.parse(strAsset)
                                                    assetName = asset.AssetName
                                                } catch (error) {
                                                    assetName = '';
                                                }
                                            }

                                            if ((props.customFieldValues || []).length) {
                                                let to = '';
                                                let cc = '';

                                                try {
                                                    let subtype = null;

                                                    //Set subtype based on currentModel
                                                    //Quote
                                                    if (workflowItem.config.currentModel === "CompensationEvent" && params.quotationid) {
                                                        subtype = "quote";
                                                    } else if (workflowItem.config.currentModel === "Rfq" && params.quotationid) { //RfqQuote
                                                        subtype = "rfqquote";
                                                    } else if (workflowItem.config.currentModel === "Itq" && params.quotationid) { //ItqQuote
                                                        subtype = "itqquote";
                                                    }

                                                    //Get cf values based on subtype or workflowid
                                                    const { data: toAndCc } = subtype
                                                        ? await customFieldCrud.getCustomFieldToAndCcValuesBySubType(props.contract.companyid, subtype, params.quotationid, itm.isReply)
                                                        : await customFieldCrud.getCustomFieldToAndCcValues(props.contract.companyid, workflowItem.id, params.notificationid, itm.isReply);

                                                    to = toAndCc.to;
                                                    cc = toAndCc.cc;
                                                } catch (error) {
                                                    to = '';
                                                    cc = '';
                                                }

                                                let location = `mailto:${to ? to + '?' : '?'}${cc ? 'cc=' + cc + '&' : ''}`;
                                                location += `subject=${encodeURIComponent(titleNotification)} ${encodeURIComponent(referenceidMailto)} on ${encodeURIComponent(nameMailto)}&body=${assetName ? encodeURIComponent(assetName + '\n') : ''}${encodeURIComponent(referenceidMailto)} on ${encodeURIComponent(nameMailto + '\n')}${urlLinkMalito}`;

                                                window.open(location, '_blank');
                                            } else {
                                                const location = `mailto:?subject=${encodeURIComponent(titleNotification)} ${encodeURIComponent(referenceidMailto)} on ${encodeURIComponent(nameMailto)}&body=${assetName ? encodeURIComponent(assetName + '\n') : ''}${encodeURIComponent(referenceidMailto)} on ${encodeURIComponent(nameMailto + '\n')}${urlLinkMalito}`;

                                                window.open(location, '_blank');
                                            }
                                        },
                                    })),
                                }

                            }
                        />

                    )
                }

                {
                    props.documentIsFinal && props.notification && listAccountsAllowedExportImportDocumentJSON.includes(userProfile.accounttype) && (
                        <ToolbarItem location="after"
                            locateInMenu="auto"
                            widget="dxDropDownButton"
                            disabled={props.saveDisabled}
                            options={
                                {
                                    text: 'Document JSON',
                                    icon: 'export',
                                    stylingMode: "outlined",
                                    type: "normal",
                                    dropDownOptions: { width: 200 },
                                    displayExpr: 'text',
                                    items: documentJsonOptions.map(itm => ({
                                        visible: itm.isReply ? props.notification.pdfreplyjsoncontent : props.notification.pdfjsoncontent,
                                        text: itm.text,
                                        onClick: itm.isReply
                                            ? (itm.isExport ? exportJSON.bind(this, props.notification.pdfreplyjsoncontent)
                                                : importJSON.bind(this, itm.isReply))
                                            : (itm.isExport ? exportJSON.bind(this, props.notification.pdfjsoncontent)
                                                : importJSON.bind(this, itm.isReply))
                                    })),
                                }
                            }
                        />

                    )
                }
                {
                    actions && actions.showModal && props.documentIsFinal && !props.parentWorkflowItem && (
                        <ToolbarItem location="after"
                            locateInMenu="auto"
                            widget="dxButton"
                            disabled={props.saveDisabled}
                            options={
                                {
                                    icon: "bell",
                                    onClick: onBtnAddActionClicked,
                                    text: intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_CREATE_RELATED_ACTION" }),
                                    stylingMode: "outlined",
                                    type: "normal"
                                }
                            }
                        />
                    )
                }
                {
                    actions && copyNotificationToOtherInstanceEnabled && props.documentIsFinal && !props.parentWorkflowItem && (
                        <ToolbarItem location="after"
                            locateInMenu="auto"
                            widget="dxButton"
                            disabled={props.saveDisabled}
                            options={
                                {
                                    icon: "copy",
                                    text: intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_COPY" }),
                                    stylingMode: "outlined",
                                    onClick: onCopyToOtherInstanceClicked,
                                }
                            }
                        />
                    )
                }
            </Toolbar>
            {
                !props.parentWorkflowItem && (
                    <ContractActionCreateModal
                        visible={showAddActionModal}
                        allowRecurrent={false}
                        onDialogResult={onAddActionDialogResult}
                        defaultSubject={`${props.referenceid} ${props.selectedClausetypeDisplay}`}
                        workflowItem={workflowItem}
                        notificationid={params.notificationid}
                        params={props.params}
                        referenceid={props.referenceid}
                    />
                )
            }
            {
                copyNotificationToOtherInstanceEnabled && (
                    <ActionCopyToOtherInstanceModal
                        visible={showActionCopyToOtherInstanceModal}
                        onDialogResult={onCopyToOtherInstanceDialogResult}
                        workflowItem={workflowItem}
                        notificationid={params.notificationid}
                        params={props.params}
                        referenceid={props.referenceid}
                        documentType={props.documentType}
                        companyId={props.contract.companyid}
                        projectId={props.contract.projectid}
                    />
                )
            }
            {
                isDownloadButtonEnabled && (
                    <ActionDownloadModal
                        visible={showActionDownloadModal}
                        onDialogResult={onDownloadActionDialogResult}
                        notificationid={params.notificationid}
                        params={props.params}
                        referenceid={props.referenceid}
                        pdfjsoncontent={props.notification.pdfjsoncontent}
                        pdfreplyjsoncontent={props.notification.pdfreplyjsoncontent}
                        noticetype={props.workflowItem.config.currentModel}
                        includemain={includemain}
                        includereply={includereply}
                    />
                )
            }


        </div>
    );
}

export default withRouter(injectIntl(withSnackbar(PageToolbar)));